export default "__VITE_PUBLIC_ASSET__f23d4ee6__"